//  [REDUCER][TYPE]
import { typeCreatorV2 } from '../../utils/common';

export const SET_LANGUAGE: string = typeCreatorV2(
  'TranslationsReducer',
  'SetLanguage'
);
